import React from "react"
import autobind from "class-autobind"
import { IWorkflow } from "../../models"
import { LinearProgress } from "material-ui"

interface IProps {
    workflow: IWorkflow
}

interface IState {
}

export default class WorkflowProgress extends React.Component<IProps, IState>  {
    constructor(props) {
        super(props)
        this.state = {
        }
        autobind(this)
    }

    render() {
        const percentDone = Math.round((this.props.workflow.CompletedStepCount / this.props.workflow.TotalStepCount) * 100)
        const title = `${this.props.workflow.CompletedStepCount}/${this.props.workflow.TotalStepCount} steps completed ${percentDone}%`
        const inProgressColor = "#1181F2"
        const finishedColor = "#4CAF50"
        const progressColor = percentDone === 100 ? finishedColor : inProgressColor

        return (
            <div>
                {title}
                <LinearProgress mode="determinate" value={this.props.workflow.CompletedStepCount} min={0} max={this.props.workflow.TotalStepCount} color={progressColor} style={{height:8}}/>
            </div>
        )
    }
}